import './triggerLeadsNotification.scss';
import {AbstractNotificationComponent} from "../AbstractNotificationComponent";

export class TriggerLeadsNotification extends AbstractNotificationComponent {

    static instance = {
        template: require('./triggerLeadsNotification.html'),
        controller: ['$scope', '$location', TriggerLeadsNotification],
        bindings: {
            'notification': '<'
        }
    };

}